const _ = {
  actions: {
    GetDownloadList({ commit, rootState }, params) {
      return mm.http({
        url: '/api/download/list',
        method: 'get',
        params:{
          a_langset_id: mm.store.state.currentLanguage,
          ...params
        }
      }).then(({ data }) => {
        return data
      })
    }
  }
}

export default _
